<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import TaskConfiguration from './TaskConfiguration/index.vue'
import TaskRecord from './TaskRecord/index.vue'
export default {
	components:{
	
	},
	data() {
		return {
			activeName:"TaskConfiguration"
		};
	},
	mounted() {
	
	},
	components:{
		TaskConfiguration,
		TaskRecord
	},
	created() {},
	methods: {
		forRouter(){
		
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
